import React, { useContext } from 'react'
import { Popconfirm, Tooltip } from 'antd'
import { Box, Button } from '@mui/material'
import { EditOutlined, CopyOutlined, DeleteOutlined } from '@ant-design/icons'
import styles from './RowAction.module.css'
import { observer } from 'mobx-react-lite'

import { ViewFormContext } from '../../../ViewForm/components/store/store.ViewForm'
import { BuilderContext } from '../../../Sandbox/components/store/store.Builder'

const RowAction = observer(
  ({
    row,
    handleEditClick,
    handleDuplicateClick,
    handleDeleteClick,
    canEdit,
  }) => {
    const viewFormContext = useContext(ViewFormContext)
    const builderContext = useContext(BuilderContext)
    const answersStore = builderContext.AnswersStore

    // Utilisation de `canEdit` pour le rendu conditionnel
    if (!canEdit) return null

    return row.original[answersStore.IdentifiantForCanEditDjango] === true ? (
      <Box sx={{ display: 'flex', flexWrap: 'nowrap', gap: '5px' }}>
        <Tooltip
          title={'Modifier'}
          placement="bottom"
          color="black"
          key={'Modifier'}
        >
          <Button
            className={styles.btn_dell_options}
            onClick={() =>
              handleEditClick(row.original[answersStore.IdentifiantForIDDjango])
            }
          >
            <EditOutlined />
          </Button>
        </Tooltip>

        <Tooltip
          title={'Dupliquer'}
          placement="bottom"
          color="black"
          key={'Dupliquer'}
        >
          <Button
            onClick={() =>
              handleDuplicateClick(
                row.original[answersStore.IdentifiantForIDDjango]
              )
            }
            className={styles.btn_dell_options}
          >
            <CopyOutlined />
          </Button>
        </Tooltip>

        <Tooltip
          title={'Supprimer'}
          placement="bottom"
          color="black"
          key={'Supprimer'}
        >
          <Popconfirm
            title="Êtes-vous sûr de vouloir supprimer cet élément?"
            onConfirm={() =>
              handleDeleteClick(
                row.original[answersStore.IdentifiantForIDDjango]
              )
            }
            okText="Oui"
            cancelText="Non"
          >
            <Button className={styles.btn_dell_options}>
              <DeleteOutlined />
            </Button>
          </Popconfirm>
        </Tooltip>
      </Box>
    ) : null
  }
)

export default RowAction
